import { useDocumentsModals } from 'modules/documents/common/contexts'

import { useZaiIframeProviderModel } from './zai-iframe-provider.model'
import type { IZaiIframeProvider } from './zai-iframe-provider.types'
import { ZaiIframeProviderView } from './zai-iframe-provider.view'

// TODO: Delete this sub-module after isNativeZaiChatEnabled is enabled for all users
export const ZaiIframeProvider = (props: IZaiIframeProvider) => {
  const { zaiChatIframeRef } = useDocumentsModals()

  const zaiIframeProviderModel = useZaiIframeProviderModel({ iframeRef: zaiChatIframeRef })

  return <ZaiIframeProviderView {...props} {...zaiIframeProviderModel} ref={zaiChatIframeRef} />
}
